enum DateUnit {
  Year,
  Month,
}

export function getTextUnit(n: number, type: DateUnit) {
  if (n < 1) return '';
  if (type === DateUnit.Year) {
    if (n === 1) return 'год';
    if (n >= 2 && n <= 4) return 'года';
    if (n >= 5) return 'лет';
  }
  if (type === DateUnit.Month) {
    if (n === 1) return 'месяц';
    if (n >= 2 && n <= 4) return 'месяца';
    if (n >= 5) return 'месяцев';
  }
}
